import { makeModuleAsync } from '@/utils';
import { carbonSummed as endpoint } from '@/config/endpoints';

export default makeModuleAsync({ endpoint });
